const Unit = () => import(/* webpackPrefetch: true */ '@/views/private/project/unit/Index.vue')
const Transaction = () => import(/* webpackPrefetch: true */ '@/views/private/project/unit/Transaction.vue')
const Booking = () => import(/* webpackPrefetch: true */ '@/components/transaction/Booking.vue')
const Other = () => import(/* webpackPrefetch: true */ '@/components/transaction/Other.vue')
const DP = () => import(/* webpackPrefetch: true */ '@/components/transaction/DP.vue')
const KPR = () => import(/* webpackPrefetch: true */ '@/components/transaction/KPR.vue')
const Development = () => import(/* webpackPrefetch: true */ '@/components/transaction/Development.vue')

const routes = [
  {
    path: "/project/unit/detail/:id",
    name: "project unit",
    component: Unit,
    meta: {
      title: "Proyek Unit"
    }
  },
  {
    path: "/project/unit/transaction",
    name: "project unit transaction",
    component: Transaction,
    meta: {
      title: "Proyek Unit Transaksi"
    },
    children: [
      {
        path: '/project/unit/transaction/booking/:id',
        name: 'project unit booking',
        component: Booking,
        meta: {
          title: "Proyek Unit Booking"
        }
      },
      {
        path: '/project/unit/transaction/other/:id',
        name: 'project unit other',
        component: Other,
        meta: {
          title: "Proyek Unit Biaya Lain-lain / Titipan"
        }
      },
      {
        path: '/project/unit/transaction/dp/:id',
        name: 'project unit dp',
        component: DP,
        meta: {
          title: "Proyek Unit Down Payment"
        }
      },
      {
        path: '/project/unit/transaction/kpr/:id',
        name: 'project unit kpr',
        component: KPR,
        meta: {
          title: "Proyek Unit Pemberkasan KPR"
        }
      },
      {
        path: '/project/unit/transaction/development/:id',
        name: 'project unit development',
        component: Development,
        meta: {
          title: "Proyek Unit Pembangunan"
        }
      },
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})